import { render, staticRenderFns } from "./NotFoundUser.vue?vue&type=template&id=05737a24"
import script from "./NotFoundUser.vue?vue&type=script&lang=js"
export * from "./NotFoundUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports